var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"font-weight-bold mb-0 status no-wrap",class:_vm.status == _vm.CheckedOut || _vm.status == _vm.DENIED || _vm.status == 'Deactivated'
      ? 'out-color'
      : 'in-color'},[_vm._v(" "+_vm._s(_vm.status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }